var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#placeholder_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "placeholder_svg__b",
  width: 15,
  height: 15,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.5 15a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#placeholder_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#8299A4",
  d: "M7.5 15a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3.5 8.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "placeholder_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h15v15H0z"
})))));
SvgPlaceholder.displayName = "SvgPlaceholder";
export { SvgPlaceholder as ReactComponent };
export default SvgPlaceholder;